<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="department_id" [(ttModel)]="menu.department_id" ttReadonly></tt-input>
        <tt-input ttLabel="department_name" [(ttModel)]="menu.department_name" [ttButtons]="departmentNameButtons" ttReadonly="true"></tt-input>
        <tt-button-goto [ttText]="'departmentmenu_edit'" [ttGoto]="'department'" [ttGotoParms]="{ department_id: menu.department_id }"></tt-button-goto>
        <tt-button ttText="departmentmenu_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
    </tt-card>
</tt-page>
